module.exports = __webpack_public_path__ + "static/img/news_23.eee7e20.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/news/news_23.png
// module id = 3iBb
// module chunks = 2